import { LocationChangeAction } from 'connected-react-router'
import { option } from 'fp-ts'
import {
  Loadable,
  Memoed,
  FailableAction,
  failableActionCreator,
  PayloadAction,
  payloadActionCreator,
  Action,
  actionCreator,
} from '@library/react-toolkit'
import { CashoutMethod } from '.'
export { CashoutMethod } from './api'

// These are just  placeholders until we know what the API will actually be
// returning.
export type Transaction = {
  id: number
  createdAt: Date
  amount: number
  unit: string
  rib: string
  status: 'success' | 'failed' | 'pending'
  type: 'incoming' | 'outgoing' | 'exchange'
  invoice: option.Option<{ id: number; reference: string }>
  cashOut: option.Option<{
    id: number
    reference: string
    method: CashoutMethod
    recipient: option.Option<string>
  }>
}

export type Query = { page: number; itemsPerPage: number }

export type TransactionData = { data: Transaction[]; count: number }

export type CashoutRequest =
  | { method: 'KIKO'; unitID: string; rib: string }
  | { method: 'PAYPAL'; unitID: string; paypalID: string }
  | { method: 'PAYMEE'; unitID: string; paymeeID: number }
  | { method: 'TRANSFER'; unitID: string; nym: string }

export type CollectFundsState = {
  selectedAsset: option.Option<string>
  result: Loadable<undefined>
}

export type State = {
  transactions: Memoed<TransactionData>
  collectFundsState: CollectFundsState
  query: Query
}

export type GetTransactionsAction = PayloadAction<
  'WALLET/get_transactions',
  Partial<Query>
>
export const getTransactionsAction =
  payloadActionCreator<GetTransactionsAction>('WALLET/get_transactions')

export type GetTransactionsResult = FailableAction<
  'WALLET/get_transactions_result',
  TransactionData
>
export const getTransactionsResult =
  failableActionCreator<GetTransactionsResult>('WALLET/get_transactions_result')

export type StartCollectionAction = PayloadAction<
  'WALLET/start_collection_action',
  string
>
export const startCollectionAction =
  payloadActionCreator<StartCollectionAction>('WALLET/start_collection_action')

export type EndCollectionAction = Action<'WALLET/end_collection_action'>
export const endCollectionAction = actionCreator<EndCollectionAction>(
  'WALLET/end_collection_action'
)

export type CollectFundsAction = PayloadAction<
  'WALLET/collect_funds',
  CashoutRequest
>
export const collectFundsAction = payloadActionCreator<CollectFundsAction>(
  'WALLET/collect_funds'
)

export type CollectFundsResult = FailableAction<
  'WALLET/collect_funds_result',
  undefined
>
export const collectFundsResult = failableActionCreator<CollectFundsResult>(
  'WALLET/collect_funds_result'
)

export type Actions =
  | GetTransactionsAction
  | GetTransactionsResult
  | CollectFundsAction
  | CollectFundsResult
  | StartCollectionAction
  | EndCollectionAction
  | LocationChangeAction
